module.exports = __webpack_public_path__ + "media/new.16b785b8.mp4";